import React from 'react'

const Favorite = ({ width, height }) => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 14.759 12.663"
      >
        <path
          d="M10.363 16.313a1.348 1.348 0 0 1-.473-.087 1.144 1.144 0 0 1-.412-.265l-.941-.849a51.729 51.729 0 0 1-3.862-3.868A5.832 5.832 0 0 1 3 7.34a3.63 3.63 0 0 1 3.69-3.69 4.414 4.414 0 0 1 1.869.45 4.717 4.717 0 0 1 1.821 1.71A4.717 4.717 0 0 1 12.2 4.1a4.414 4.414 0 0 1 1.869-.453 3.63 3.63 0 0 1 3.69 3.69 5.885 5.885 0 0 1-1.742 3.987q-1.742 1.912-3.814 3.791l-.936.845a1.117 1.117 0 0 1-.421.265 1.443 1.443 0 0 1-.481.087zM9.98 6.665a5.206 5.206 0 0 0-1.532-1.692 3.218 3.218 0 0 0-1.758-.5A2.8 2.8 0 0 0 3.82 7.34a3.916 3.916 0 0 0 .514 1.86 10.966 10.966 0 0 0 1.381 1.956 26.7 26.7 0 0 0 1.991 2.048q1.126 1.047 2.343 2.156a.5.5 0 0 0 .663 0q1.217-1.109 2.343-2.156a26.406 26.406 0 0 0 1.991-2.047A10.966 10.966 0 0 0 16.425 9.2a3.916 3.916 0 0 0 .514-1.863 2.8 2.8 0 0 0-2.87-2.87 3.218 3.218 0 0 0-1.758.5 5.194 5.194 0 0 0-1.531 1.698.408.408 0 0 1-.175.166.49.49 0 0 1-.451 0 .408.408 0 0 1-.175-.166zm.4 3.335z"
          transform="translate(-3 -3.65)"
          style={{ fill: '#b1b1b1' }}
        />
      </svg>
    </div>
  )
}

export default Favorite
